import type { PropTrackerOutcome } from '@/utils/propBasedDailyReveal';

type PropOutcomeIconProps = {
  outcome: PropTrackerOutcome;
  className?: string;
};

/** Green check / red X from Figma live-scoring cards. */
export default function PropOutcomeIcon({
  outcome,
  className = 'h-6 w-6 shrink-0',
}: PropOutcomeIconProps) {
  if (outcome !== 'hit' && outcome !== 'miss') return null;

  return (
    <img
      src={outcome === 'hit' ? '/shapes/correct.svg' : '/shapes/incorrect.svg'}
      alt={outcome === 'hit' ? 'Hit' : 'Miss'}
      className={className}
    />
  );
}
